import React, { useState } from "react";

// Style \\
import "../../assets/styles/sections/colculationSection.scss";

// Icons \\
import { MdDelete } from "react-icons/md";

const ColculationSection = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [selectedThickness, setSelectedThickness] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [onPizza, setOnPizza] = useState([]);
  const [addPizza, setAddPizza] = useState([]);
  const [orders, setOrders] = useState([]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleThicknessChange = (e) => {
    setSelectedThickness(e.target.value);
  };

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };

  const handleOnPizzaChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setOnPizza((prevOnPizza) => [...prevOnPizza, value]);
    } else {
      setOnPizza((prevOnPizza) => prevOnPizza.filter((item) => item !== value));
    }
  };

  const handleAddPizzaChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setAddPizza((prevAddPizza) => [...prevAddPizza, value]);
    } else {
      setAddPizza((prevAddPizza) =>
        prevAddPizza.filter((item) => item !== value)
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // const max = 100;
    // form.reset();

    const newOrder = {
      id: Math.random().toFixed(1),
      username: name,
      phone,
      address,
      prosuctSize: selectedThickness,
      pizzaSize: selectedSize,
      onPizza,
      addPizza,
      total: calculateTotalCost(),
    };

    console.log(newOrder.id);

    setOrders((prevOrders) => [...prevOrders, newOrder]);

    // Reset form fields
    setName("");
    setPhone("");
    setAddress("");
    setSelectedThickness("");
    setSelectedSize("");
    setOnPizza([]);
    setAddPizza([]);
  };

  const calculateTotalCost = () => {
    let total = 0;

    // Calculate the cost based on the selected options
    if (selectedThickness === "oak") {
      total += 10;
    } else if (selectedThickness === "Mahogany") {
      total += 12;
    } else if (selectedThickness === "Pine") {
      total += 15;
    }

    if (selectedSize === "red") {
      total += 10;
    } else if (selectedSize === "black") {
      total += 12;
    } else if (selectedSize === "green") {
      total += 15;
    }

    total += onPizza.length * 5;
    total += addPizza.length * 3;

    return total;
  };

  console.log(orders);

  const handleDeleteOrder = (orderId) => {
    setOrders((prevOrders) =>
      prevOrders.filter((order) => order.id !== orderId)
    );
  };

  return (
    <section className="colculationSection">
      <div className="containers">
        <div className="pizza-order-form py-20">
          <div className="form_box flex  justify-between items-center">
            <div className="content">
              <h4>Fill out the form!</h4>
              <p className="text-xl">
                Order furniture by filling out the form. Choose section
              </p>
            </div>
            <form className="myForm" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={handleNameChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone:</label>
                <input
                  type="text"
                  id="phone"
                  value={phone}
                  onChange={handlePhoneChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="address">Address:</label>
                <input
                  type="text"
                  id="address"
                  value={address}
                  onChange={handleAddressChange}
                />
              </div>
              <div className="form-group select">
                <label htmlFor="selectThickness">Type of wood:</label>
                <select
                  id="selectThickness"
                  value={selectedThickness}
                  onChange={handleThicknessChange}
                >
                  <option value="">Type of wood</option>
                  <option value="oak">oak</option>
                  <option value="Mahogany">Mahogany</option>
                  <option value="Pine">Pine</option>
                </select>
              </div>
              <div className="form-group select">
                <label htmlFor="selectSize">Size:</label>
                <select
                  id="selectSize"
                  value={selectedSize}
                  onChange={handleSizeChange}
                >
                  <option value="">Select Color</option>
                  <option value="red">red</option>
                  <option value="black">black</option>
                  <option value="green">green</option>
                </select>
              </div>
              <div className="select-box flex justify-between">
                <div className="form-group select">
                  <p className=" font-bold">what type of furniture :</p>
                  <label>
                    <input
                      className="check"
                      type="checkbox"
                      value="Sofa"
                      onChange={handleOnPizzaChange}
                    />
                    Sofa
                  </label>
                  <label>
                    <input
                      className="check"
                      type="checkbox"
                      value="Chair"
                      onChange={handleOnPizzaChange}
                    />
                    Chair
                  </label>
                  <label>
                    <input
                      className="check"
                      type="checkbox"
                      value="table"
                      onChange={handleOnPizzaChange}
                    />
                    table
                  </label>
                </div>
                <div className="form-group select">
                  <p className=" font-bold">Add +:</p>
                  <label>
                    <input
                      className="check"
                      type="checkbox"
                      value="Pillows"
                      onChange={handleAddPizzaChange}
                    />
                    Pillows
                  </label>
                  <label>
                    <input
                      className="check"
                      type="checkbox"
                      value="lights"
                      onChange={handleAddPizzaChange}
                    />
                    lights
                  </label>
                </div>
              </div>
              <button type="submit">Submit</button>
            </form>
          </div>
          <div className="ordered-list flex flex-wrap justify-between">
            {orders.map((order) => (
              <div key={order.id} className="cardCalculate">
                <div className="title d-flex justify-content-between align-items-center">
                  <h4 className=" object-none">dddd</h4>
                  <MdDelete
                    className="delete"
                    onClick={() => handleDeleteOrder(order.id)}
                  />
                </div>
                <div className="info_user">
                  <p>
                    <span className="fw-bold">Name: </span>
                    {order.username}
                  </p>
                  <p>
                    <span className="fw-bold">Phone: </span>
                    {order.phone}
                  </p>
                  <p>
                    <span className="fw-bold">Address: </span>
                    {order.address}
                  </p>
                </div>
                <hr />
                <div className="info_pizza">
                  <p>
                    <span className="fw-bold">Type of wood: </span>
                    {order.prosuctSize}
                  </p>
                  <p>
                    <span className="fw-bold">Color: </span>
                    {order.pizzaSize}
                  </p>
                  <p>
                    <span className="fw-bold">Type of furniture: </span>
                    {order.onPizza.join(", ")}
                  </p>
                  <p>
                    <span className="fw-bold">Add +: </span>
                    {order.addPizza.join(", ")}
                  </p>
                </div>
                <hr />
                <div className="text-end">
                  <h5>
                    <span>Total: $ {order.total}</span>
                  </h5>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="border"></div>
      </div>
    </section>
  );
};

export default ColculationSection;
